/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-use-before-define
import React, { FC, useEffect, useState } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { PartnerCategory } from 'types';

import { setModal } from 'modules/_shared/redux/modalActions';
import {
  createPartnerCategory,
  updatePartnerCategory,
} from 'modules/partners/redux/partnerCategoryActions';
import { badgeStyles } from 'modules/_shared/constants/badgeStyles';

import { State } from 'redux/initialState';

import actionTypes from 'constants/actionTypes';

import '../Modals.scss';

type PartnerCategoryModalProps = {
  action: string;
  currentPartnerCategory: PartnerCategory;
};

const PartnerCategoryModal: FC<PartnerCategoryModalProps> = ({
  action = 'ADD',
  currentPartnerCategory,
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [style, setStyle] = useState('');

  function savePartnerCategory(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const newPartnerCategory = {
      name,
      description,
      society: actualSociety['_id'],
      style,
    };

    if (action === actionTypes.EDIT) {
      dispatch(
        updatePartnerCategory(currentPartnerCategory['_id'], newPartnerCategory)
      );
    } else {
      dispatch(createPartnerCategory(newPartnerCategory));
    }

    dispatch(setModal(null));
  }

  const handleChangeColorInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const color = event.target.value;
    setStyle(color);
  };

  const getLabelStyle = (color: string, currentColor: string) => ({
    boxShadow: currentColor === color ? `#000000 0px 0px 4px` : 'none',
  });

  useEffect(() => {
    if (action === actionTypes.EDIT) {
      const name = currentPartnerCategory?.isDefault
        ? t(currentPartnerCategory?.name)
        : currentPartnerCategory?.name;
      const description = currentPartnerCategory?.isDefault
        ? t(currentPartnerCategory?.description)
        : currentPartnerCategory?.description;

      setName(name);
      setDescription(description);
      setStyle(currentPartnerCategory?.style);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title">
          {action === actionTypes.EDIT ? t('Edit') : t('Add')}{' '}
          {` ${t('PartnerCategory')}`}
        </h5>
        <a
          className="close cursor-pointer"
          onClick={() => dispatch(setModal(null))}
        >
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>

      <Modal.Body>
        <form
          className="form-validate is-alter"
          onSubmit={(event) => savePartnerCategory(event)}
        >
          <div className="form-group">
            <label className="form-label" htmlFor="category-name">
              {t('CategoryName')}
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                id="category-name"
                className="form-control"
                value={name}
                onChange={(event) => setName(event.target.value)}
                placeholder={t('Socios Fundadores')}
                required
                disabled={currentPartnerCategory?.isDefault}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="category-description">
              {t('Description')}
            </label>
            <div className="form-control-wrap">
              <div className="form-editor-custom">
                <textarea
                  id="category-description"
                  className="form-control form-control-lg no-resize"
                  placeholder={t('Agrupamos a los principales socios')}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={currentPartnerCategory?.isDefault}
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="category-description">
              {t('Style')}
            </label>
            <div className="form-control-wrap">
              <div className="data-col data-col-end w-100">
                <ul className="custom-control-group vertical-align-middle d-flex flex-row">
                  {badgeStyles.map((color, index) => (
                    <li className="w-60px" key={`badge-${index}-${color}`}>
                      <div className="custom-control color-control">
                        <input
                          type="radio"
                          className={`custom-control-input `}
                          id={`badge-${index}-${color}`}
                          name="badge-color-input"
                          value={color}
                          onChange={handleChangeColorInput}
                        />
                        <label
                          className={`custom-control-label color-selector-item bg-${color}`}
                          data-bg={color}
                          htmlFor={`badge-${index}-${color}`}
                          style={getLabelStyle(color, style)}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-lg btn-primary mt-4"
            disabled={!name}
          >
            {action === actionTypes.EDIT ? t('ToUpdate') : t('Add')}{' '}
            {t('Category')}
          </button>
        </form>
      </Modal.Body>
    </>
  );
};

export default PartnerCategoryModal;
